import { gql } from "@apollo/client";

export default gql`
  fragment PerformanceAssessmentChartLabelQuestion on AssessmentQuestionInterface {
    ... on RangeAssessmentQuestionNode {
      id
    }
    ... on IndividualGoalAssessmentQuestionNode {
      id
    }
    ... on OverallGoalAssessmentQuestionNode {
      id
    }
    ... on IndividualRecognitionCoreValueAssessmentQuestionNode {
      id
    }
    ... on OverallRecognitionCoreValueAssessmentQuestionNode {
      id
    }
    ... on CompetencyAssessmentQuestionNode {
      id
    }
    ... on CompetencyCriteriaAssessmentQuestionNode {
      id
    }
    ... on ResponsibilityAssessmentQuestionNode {
      id
    }
    ... on TalentIndicatorAssessmentQuestionNode {
      id
    }
    ... on MultiChoiceAssessmentQuestionNode {
      id
    }
    ... on TextAssessmentQuestionNode {
      id
    }
    ... on NpsAssessmentQuestionNode {
      id
    }
  }
`;
